import script from "./add-game-to-library.vue?vue&type=script&setup=true&lang=ts"
export * from "./add-game-to-library.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__